import { InvalidConsideredOption, isValidOption, Option } from '../../types';
import { IconCheckCircleFill } from '@cimpress-ui/react/icons';
import { IconErrorFill } from '@cimpress-ui/react/icons';
import { IconWarningFill } from '@cimpress-ui/react/icons';

export const OptionStatus = ({ option }: { option: Option | InvalidConsideredOption }) => {
  if (isValidOption(option)) {
    if (option.isSelected) {
      return <IconCheckCircleFill tone="success" size={32} data-testid="check-circle-icon" />;
    } else {
      return <IconWarningFill tone="warning" size={32} data-testid="remove-circle-icon" />;
    }
  }

  return <IconErrorFill tone="critical" size={32} data-testid="alert-triangle-icon" />;
};
